import type { ReactNode } from 'react';

export type Option<T> = {
  label: string;
  value: T;
  disabled?: boolean;
  active?: boolean;
  description?: string;
};

export type Translations = {
  header?: string;
  footer?: string;
  bulkActionTooltip?: string;
  noEntries?: string;
};

export enum SortOrder {
  ASC = 'ASC',
  DESC = 'DESC',
}

export type FormatOptionLabelReactNode<T> = (option: Option<T>) => Exclude<ReactNode, string>;

export type FormatOptionLabelString<T> = (option: Option<T>) => string;

export type FormatOptionLabel<T> = FormatOptionLabelString<T> | FormatOptionLabelReactNode<T>;
